import { render, staticRenderFns } from "./list-task.vue?vue&type=template&id=88e54eb4&scoped=true"
import script from "./list-task.vue?vue&type=script&lang=js"
export * from "./list-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e54eb4",
  null
  
)

export default component.exports